import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryShowcase() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            探索各种题材，发现你的专属韩漫
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all mb-4">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 text-center leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}